import React from "react"

interface IProps {
  menuData: IMenuItem
}

import TwoColumnSubmenu from "@/components/header/menu/two-column-submenu"
import t from "@/constants/wording"
import MenuLink from "@/components/header/menu/menu-link"

const ContactUsMenu: React.FC<IProps> = ({ menuData }) => {
  return (
    <div>
      <TwoColumnSubmenu menuData={menuData} />
      <div style={{ padding: "0 0 2rem 2rem" }}>
        <MenuLink link={"/contact"}>
          <button className="button is-primary">{t("contact us")}</button>
        </MenuLink>
      </div>
    </div>
  )
}

export default ContactUsMenu
